import { withAutoScrollable } from '@src/components/base/AutoScrollable'
import { BLURRED_CARD_KEY } from '@src/components/Cards/constants'
import TermsAndConditions from '@src/components/TermsAndConditions'
import { handleFreeTrialStart } from '@src/state/payment/actions'
import { selectPlusSiteName } from '@src/state/site/selectors'
import { SiteState } from '@src/state/site/types'
import { RootState } from '@src/state/types'
import {
  GET_STARTED,
  selectShouldScrollBlurredCard,
  selectShowTermsLink,
  START_FREE_TRIAL,
  START_SUBSCRIPTION,
} from '@src/state/workspace/selectors'
import usePriceTest from '@src/utils/hooks/usePriceTest'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import * as Styled from './styles'
import {
  BlurredCardDispatchProps,
  BlurredCardProps,
  BlurredCardStateProps,
} from './types'

export const UPGRADE_BUTTON = 'upgradeButton'
export const GRAMMAR_LOCK = 'grammar lock'
export const GRAMMAR_UPSELL_CONTROL = 'grammarUpsellControl'
export const UPSELL_GRAMMAR_SUGGESTIONS = 'upsellGrammarSuggestions'

interface UseUpgradeButtonTextProps {
  site: SiteState
  cspUpsellHasFreeTrial: boolean
}

export const useUpgradeButtonText = ({
  site,
  cspUpsellHasFreeTrial,
}: UseUpgradeButtonTextProps): string => {
  if (usePriceTest({ site }).freeTrial === false) {
    return GET_STARTED
  }

  if (!cspUpsellHasFreeTrial) {
    return START_SUBSCRIPTION
  }

  return START_FREE_TRIAL
}

const GrammarUpsellControl: React.FunctionComponent<BlurredCardProps> = ({
  upgrade,
  shouldScroll,
  phone,
  siteName,
  site,
  cspUpsellHasFreeTrial,
}) => {
  const Scrollable = withAutoScrollable(Styled.BlurredCardContainer)
  const buttonCopy = useUpgradeButtonText({ site, cspUpsellHasFreeTrial })

  return (
    <Scrollable
      inline="start"
      key={BLURRED_CARD_KEY}
      shouldScroll={shouldScroll}
      data-test={GRAMMAR_UPSELL_CONTROL}
    >
      <Styled.BlurredCardHeader phone={phone} />
      <Styled.BlurContainer>
        <Styled.Heading data-test={UPSELL_GRAMMAR_SUGGESTIONS}>
          Try {siteName} to get all grammar suggestions
        </Styled.Heading>
        <Styled.UpgradeButton data-test={UPGRADE_BUTTON} onClick={upgrade}>
          {buttonCopy}
        </Styled.UpgradeButton>
        {cspUpsellHasFreeTrial && <TermsAndConditions />}
      </Styled.BlurContainer>
    </Scrollable>
  )
}

const mapStateToProps = (state: RootState) => ({
  shouldScroll: selectShouldScrollBlurredCard(state),
  siteName: selectPlusSiteName(state),
  site: state.site,
  cspUpsellHasFreeTrial: !!selectShowTermsLink(state),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  upgrade: () => dispatch(handleFreeTrialStart(GRAMMAR_LOCK)),
})

export default connect<BlurredCardStateProps, BlurredCardDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(GrammarUpsellControl)



// WEBPACK FOOTER //
// ./src/layouts/shared/BlurredCard/index.tsx